<template>
	<div>
		<AppFilter @apply="onFilter" v-model="filters" @retainValues = "retainFilter" ref="appFilter"/>
	</div>
</template>

<script>
	import AppFilter from "@/components/core/indexNew.vue";
	export default {
		props: {
			profileTags: {},
		},
		beforeMount() {},
		components: {
			AppFilter
		},
		watch: {
			profileTags () {
				console.log(this.profileTags)
				this.setFilters()
			},
		},
		computed: {
			campaignsFilter:{
				set(val){
					this.$store.commit('updateDspFilter',val)
				},
				get(){
					return this.$store.state.dspFilter
				}
			},
			// selectedCampaignList: {
			// 	get() {
			// 		return this.$store.state.campaign.campaignToAddToGroupList;
			// 	},
			// 	set(val) {
			// 		this.$store.state.campaign.campaignToAddToGroupList = val;
			// 	}
			// },
			actionSelectionControl: {
				set(val) {
					this.$store.state.campaign.actionSelectionControl = val
				},
				get() {
					return this.$store.state.campaign.actionSelectionControl
				}
			},
		},
		async mounted() {
			if(Object.keys(this.$store.state.campaign.advanceFilter).length && this.dspFilter.length){
				this.filters = JSON.parse(JSON.stringify(this.dspFilter))
				this.$refs["appFilter"].setFilterActive();
			}
			else{
				this.setFilters();
			}
		},
		methods: {
			retainFilter(data){
				if(Object.keys(this.$store.state.campaign.advanceFilter).length){
					this.filters = JSON.parse(JSON.stringify(this.dspFilter)) || []
				}
				else{
					this.filters = JSON.parse(JSON.stringify(data)) 
				}
				
			},
			async onFilter(input) {
				let filters = {};
				for (var i = 0; i < input.length; i++) {
					filters[input[i].name] = input[i].value;
                }

				filters.advanceSearchType = "dsp";
				// let payload = {tags: {}};
				let payload = {tags: []}
				//campaign tag section
				if(filters['brand_tag']){
					// payload.tags.brand = filters['brand_tag']
					payload.tags.push(filters['brand_tag'])
				}
				if(filters['category_tag']){
					// payload.tags.category = filters['category_tag']
					payload.tags.push(filters['category_tag'])
				}
				if(filters['subcategory_tag']){
					// payload.tags.subcategory = filters['subcategory_tag']
					payload.tags.push(filters['subcategory_tag'])
				}
				if(filters['style_tag']){
					// payload.tags.style = filters['style_tag']
					payload.tags.push(filters['style_tag'])
				}
				if(filters['tactic1_tag']){
					// payload.tags.tactic1 = filters['tactic1_tag']
					payload.tags.push(filters['tactic1_tag'])
				}
				if(filters['tactic2_tag']){
					// payload.tags.tactic2 = filters['tactic2_tag']
					payload.tags.push(filters['tactic2_tag'])
				}
				if(filters['gl_tag']){
					// payload.tags.gl = filters['gl_tag']
					payload.tags.push(filters['gl_tag'])
				}

				// payload.advertiser_id = this.$store.state.dspAdvertiser.value
				
				this.resetCampAction();
				this.$store.state.currentPageNumber = 1;
				this.$store.commit("campaign/setadvanceFilterAttributes", payload);
				// console.log(this.$store.state.advanceFilter)
				// console.log('DSPADVERTISER ',this.$store.state.dspAdvertiser.value)
				payload.advertiser_id = this.$store.state.dspAdvertiser ? this.$store.state.dspAdvertiser.value : undefined
				this.$store.dispatch("getAllDsp", payload);
			},
			resetCampAction(){
				this.actionSelectionControl = false
				// this.selectedCampaignList = []
			},
			setFilters() {
				this.filters = [];

				this.filters = [
                    {
						name: "break",
						type: "break"
					},
					{
						name: "brand_tag",
						label: "Brand Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select Brand",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'brand') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'brand') || []).length,
						values: [{title: 'UNTAGGED', type:'brand', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'brand')),
						color: "#2F5BC2"
                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "category_tag",
						label: "Category Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select Category",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'product_category') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'product_category') || []).length,
						values: [{title: 'UNTAGGED', type:'product_category', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'product_category')),
						color: "#1C919E"

                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "subcategory_tag",
						label: "Sub-Category Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select Subcategory",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'subcategory') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'subcategory') || []).length,
						values: [{title: 'UNTAGGED', type:'subcategory', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'subcategory')),
						color: "#D98F34"
                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "style_tag",
						label: "Style Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select Style",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'style') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'style') || []).length,
						values: [{title: 'UNTAGGED', type:'style', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'style')),
						color: "#6A61BA"

                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "tactic1_tag",
						label: "Tactic 1 Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select Tactic 1",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'tactic_1') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'tactic_1') || []).length,
						values: [{title: 'UNTAGGED', type:'tactic_1', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'tactic_1')),
						color: "#60AEF7"

                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "tactic2_tag",
						label: "Tactic 2 Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select Tactic 2",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'tactic_2') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'tactic_2') || []).length,
						values: [{title: 'UNTAGGED', type:'tactic_2', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'tactic_2')),
						color: "#C94024"

                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "gl_tag",
						label: "GL Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select GL",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'gl') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'gl') || []).length,
						values: [{title: 'UNTAGGED', type:'gl', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'gl')),
						color: "#5E5E5E"
                    },
					{
						name: "break",
						type: "break"
                    },

				];
				this.campaignsFilter = JSON.parse(JSON.stringify(this.filters))
			},
		},
		data() {
			return {
				filters: [],
			};
		}
	};
</script>
<style lang="scss">
.multiselect__content-wrapper {
	z-index: 1001;
}
</style>
